{
  "main": {
    "title": "Camo pregledi"
  },
  "menu": {
    "plovila": {
      "title": "Plovila",
      "description": "Pregled št letov, skupnih ur"
    },
    "liste": {
      "title": "Štartne liste",
      "description": "Pregled štartnih list"
    }
  }
}